// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.psi-account-tab[data-v-a7d1f636] {\n    width: 165px;\n}\n", ""]);
// Exports
module.exports = exports;
